module.exports = __webpack_public_path__ + "img/Manual Insertion Conveyor.e6e778dc.jpg";